export const values = [
  "thinkClearly",
  "beResourceful",
  "stayDetermined",
  "dreamBig",
  "takeOwnership",
  "remainHumble",
]
